export { default as TextImage } from './TextImage';